import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const Badge = styled('span')`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 1px 4px;
  margin-right: 4px;
  border-radius: 2px;
  background: var(--dk-danger-soft, #fde3e6);
  color: var(--dk-danger, #f55060);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

/** 퇴사자 '퇴사' 배지 — 작성 결재라인 행 / 조회 결재라인 카드 공용 (스펙 단일 지점) */
const DeactivatedBadge = () => {
  const { t } = useTranslation();
  return <Badge>{t('퇴사')}</Badge>;
};

export default DeactivatedBadge;
